import { useContext } from "react";
import { UnauthenticatedLocaleContext } from "../providers/UnauthenticatedLocaleProvider";
import { AuthenticatedLocaleContext } from "../providers/AuthenticatedLocaleProvider";
import { useAuth } from "src/apps/hooks/useAuth";

export function useLocale() {
  const { token } = useAuth();
  const context = getContext(token);
  const { locale, setLocale, availableLocales } = useContext(context);

  return { locale, setLocale, availableLocales };
}

function getContext(token: string) {
  if (token) {
    return AuthenticatedLocaleContext;
  } else {
    return UnauthenticatedLocaleContext;
  }
}
